import React, { Fragment, useEffect } from "react"
import { Button, Form } from "react-bootstrap"
import Pagination from "./Pagination"
import PrimaryButton from "../subComponents/PrimaryButton"
import ImageModel from "./ImageModel"
import { Link } from "react-router-dom"
// import { FaSort } from "react-icons/fa6"
import "../../css/ToggleSwitch.css"

export interface OptionData {
  value: string
  label: string
  disabled?: any
}
export interface FilterData {
  label: string
  type: string
  value?: any
  onChange?: any
  onClick?: any
  disabled?: boolean
  className?: string
  option?: OptionData[]
  icon?: any
  min?: any
  max?: any
}
export interface TableAction {
  label: string | ((row: any) => string)
  onClick?: (row: any) => void
  className?: string
  icon?: React.ReactNode
  disabled?: boolean
  isRedirect?: boolean
  link?: string | ((row: any) => string)
}

export interface TableHeadProp {
  name: any
  sort?: boolean
  sortBy?: string
  className?: string
  value: any
  type?: string
  id: string
  onToggle?: any
}
type Props = {
  columns: TableHeadProp[]
  rowData: any
  page: number
  paginate?: boolean
  setPage: (page: number) => void
  rowsPerPage: number
  setRowsPerPage: (limit: number) => void
  totalItems: number
  sortColumn?: string | null
  setSortColumn?: any
  setSelected?: any
  setSortOrder?: any
  sortOrder?: string | null
  action?: TableAction[]
  isSearch?: boolean
  addAction?: any
  search?: string
  setSearch?: (search: string) => void
  filterData?: FilterData[]
  multipleFilters?: any
  bulkActions?: any
  shouldResetCheckbox?: any
  setShouldResetCheckbox?: any
}
function Table(props: Props) {
  const {
    page,
    setPage,
    rowsPerPage,
    paginate = true,
    setRowsPerPage,
    totalItems,
    columns,
    rowData,
    sortColumn = null,
    setSortColumn,
    setSortOrder,
    sortOrder = "",
    action = [],
    setSelected,
    addAction,
    isSearch = false,
    bulkActions,
    search = "",
    setSearch,
    filterData,
    multipleFilters,
    shouldResetCheckbox = false,
    setShouldResetCheckbox,
  } = props
  const [selectedRows, setSelectedRows] = React.useState<any[]>([])
  const [isModalOpen, setModalOpen] = React.useState(false)
  const [selectedImage, setSelectedImage] = React.useState<any>(null)

  // Function to handle checkbox change
  const handleSelectAll = () => {
    const updatedArray = [...selectedRows]
    if (setSelected) {
      setSelected(updatedArray)
    }
    if (selectedRows.length !== rowData.length) {
      rowData.forEach((row: any) => {
        const index = updatedArray.findIndex((selectedrowData) => selectedrowData.id === row.id)
        if (index === -1) {
          updatedArray.push(row)
        }
      })
      setSelectedRows(updatedArray)
    } else {
      setSelectedRows([])
      if (setSelected) {
        setSelected([])
      }
    }
  }

  useEffect(() => {
    if (shouldResetCheckbox) {
      if (setShouldResetCheckbox) {
        setShouldResetCheckbox(false)
      }
      setSelectedRows([])
    }
  }, [shouldResetCheckbox, setShouldResetCheckbox])

  const handleCheckboxChange = (value: any) => {
    const updatedArray = [...selectedRows]
    if (setSelected) {
      setSelected(updatedArray)
    }
    const index = selectedRows?.findIndex((rowData) => rowData.id === value.id)
    if (index === -1) {
      updatedArray.push(value)
    } else {
      updatedArray.splice(index, 1)
    }
    setSelectedRows(updatedArray)
  }

  const handleSort = (columnId: string) => {
    let newOrder: "ASC" | "DESC" | null = "ASC"

    if (sortColumn === columnId) {
      if (sortOrder === "ASC") {
        newOrder = "DESC"
      } else if (sortOrder === "DESC") {
        newOrder = null // Reset sorting (original order)
      }
    }

    setSortColumn(newOrder ? columnId : null)
    setSortOrder(newOrder)
  }

  return (
    <div className='table-mian-section'>
      <div className='row mb-3 table-topbar'>
        <div className='col-12 col-md-5'>
          <div className='searchBar-main-section '>
            {isSearch && (
              <div className='search-bar-section table-searchBar'>
                <input
                  type='text'
                  placeholder='Search...'
                  className='search-input'
                  onChange={(e) => {
                    // Handle search input change
                    setSearch && setSearch(e.target.value)
                  }}
                  value={search}
                />
              </div>
            )}
          </div>
        </div>
        {addAction && (
          <div className='col-12 col-md-7'>
            <div className='filter-section d-flex justify-content-end'>
              <Button
                disabled={addAction?.disabled}
                className={addAction.className}
                onClick={() => {
                  addAction.onClick()
                  if (setSelected) {
                    setSelectedRows([])
                  }
                }}
              >
                {addAction.label}
              </Button>
            </div>
          </div>
        )}
        {filterData && (
          <div className='col-12 col-md-7 mt-2'>
            <div className='filter-section'>
              {filterData &&
                filterData.map((filter: FilterData, filterIndex: number) => {
                  return (
                    <Fragment key={filterIndex}>
                      <div className='filter-option-sectin'>
                        {filter.type !== "button" && (
                          <label className='filter-title'>{filter.label}</label>
                        )}
                        {(filter.type === "text" || filter.type === "date") && (
                          <input
                            type={filter.type}
                            value={filter.value}
                            className={filter.className}
                            onChange={filter.onChange}
                            disabled={filter.disabled ? filter.disabled : false}
                          />
                        )}

                        {filter.type === "select" && (
                          <select
                            value={filter.value}
                            className={`form-select ${filter.className}`}
                            onChange={filter.onChange}
                            disabled={filter.disabled ? filter.disabled : false}
                          >
                            {filter.option &&
                              filter.option.map((opt: OptionData, optIndex: number) => (
                                <option key={optIndex} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                          </select>
                        )}
                        {filter.type === "button" && (
                          // <Button className={filter.className} onClick={filter.onClick}>
                          //   {filter.icon && filter.icon}
                          //   {filter.label}
                          // </Button>
                          <PrimaryButton
                            icon={filter.icon && filter.icon}
                            label={filter.label}
                            className={filter.className}
                            onClick={filter.onClick}
                          />
                        )}
                      </div>
                    </Fragment>
                  )
                })}
            </div>
          </div>
        )}
      </div>
      {multipleFilters && (
        <div className='row mb-3 table-topbar'>
          <div className='col-12 col-md-12'>
            <div className='col-12 col-md-12'>
              <div className='filter-section'>
                {multipleFilters &&
                  multipleFilters.map((filter: FilterData, filterIndex: number) => {
                    return (
                      <Fragment key={filterIndex}>
                        <div className='filter-option-sectin'>
                          {filter.type !== "button" && (
                            <label className='filter-title'>{filter.label}</label>
                          )}
                          {(filter.type === "text" || filter.type === "date") && (
                            <input
                              type={filter.type}
                              value={filter.value}
                              className={filter.className}
                              onChange={filter.onChange}
                              disabled={filter.disabled ? filter.disabled : false}
                            />
                          )}

                          {filter.type === "datetime-local" && (
                            <input
                              type={filter.type}
                              value={filter.value}
                              className={filter.className}
                              onChange={filter.onChange}
                              disabled={filter.disabled ? filter.disabled : false}
                              {...(filter.min !== undefined ? { min: filter.min } : {})}
                              {...(filter.max !== undefined ? { max: filter.max } : {})}
                            />
                          )}

                          {filter.type === "select" && (
                            <select
                              value={filter.value}
                              className={`form-select ${filter.className}`}
                              onChange={filter.onChange}
                              disabled={filter.disabled ? filter.disabled : false}
                            >
                              {filter.option &&
                                filter.option.map((opt: OptionData, optIndex: number) => (
                                  <option key={optIndex} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                            </select>
                          )}
                          {filter.type === "button" && (
                            // <Button className={filter.className} onClick={filter.onClick}>
                            //   {filter.icon && filter.icon}
                            //   {filter.label}
                            // </Button>
                            <PrimaryButton
                              icon={filter.icon && filter.icon}
                              label={filter.label}
                              className={filter.className}
                              onClick={filter.onClick}
                            />
                          )}
                        </div>
                      </Fragment>
                    )
                  })}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className='table-section'>
        <table>
          <thead>
            <tr>
              <th className='checkbox'>
                <Form.Check
                  type='checkbox'
                  id='default-checkbox'
                  onChange={handleSelectAll}
                  checked={rowData.length === selectedRows.length}
                  // checked={rowData.every(
                  //     (row: any) => row.selected
                  // )}
                />
              </th>
              <th className='srNo'>
                <h4>Sr.No</h4>
              </th>
              {columns.map((column, index) => (
                <th
                  key={index}
                  className={column.className}
                  onClick={() => {
                    column.sort ? handleSort(column.id) : console.log("sort")
                  }}
                >
                  <div className='table-name'>
                    <h4>{column.name}</h4>
                    {sortColumn === column.id ? (
                      <h4 className=' cursor-pointer'>{sortOrder === "ASC" ? "▲" : "▼"}</h4>
                    ) : column.sort ? (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        strokeWidth={1.5}
                        stroke='currentColor'
                        className='size-6'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9'
                        />
                      </svg>
                    ) : (
                      ""
                    )}
                  </div>
                </th>
              ))}
              {action.length > 0 && (
                <th colSpan={2}>
                  <h4 className='text-center'>Action</h4>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {
              rowData.length > 0 &&
                rowData.map((row: any, index: number) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td>
                        <Form.Check
                          type='checkbox'
                          id={`customer-checkbox-${index}`}
                          onChange={() => handleCheckboxChange(row)}
                          checked={selectedRows.some((r) => r.id === row.id)}
                        />
                      </td>
                      <td className='srNo'>
                        <h4>{rowsPerPage * (page - 1) + index + 1}</h4>
                      </td>
                      {columns.map((column, colIndex) => (
                        <td key={colIndex + column.id}>
                          {/* <h4 className={column.className || ""}>{column.value(row)}</h4> */}
                          {column.type === "planimage" ? (
                            <img
                              src={column.value(row).planimage}
                              alt={column.id}
                              className={column.className || ""}
                              onClick={() => {
                                setSelectedImage(column.value(row))
                                setModalOpen(true)
                              }}
                            />
                          ) : column.type === "switch" ? (
                            <div className='toggle-container'>
                              <label className='switch'>
                                <input
                                  type='checkbox'
                                  checked={column.value(row)}
                                  onChange={() => column.onToggle(row)}
                                />
                                <span className='slider' />
                              </label>
                            </div>
                          ) : (
                            <h4 className={column.className || ""}>{column.value(row)}</h4>
                          )}
                        </td>
                      ))}
                      {action.map((act: any, actionIndex: number) => (
                        <td className='action-btn-section' key={actionIndex}>
                          {act?.isRedirect ? (
                            <Link
                              to={typeof act.link === "function" ? act.link(row) : act.link}
                              className={`table-actions ${act.className || ""} ${
                                act.disabled ? "disabled" : ""
                              }`}
                            >
                              {act.icon && <>{act.icon}</>}
                              {typeof act.label === "function" ? act.label(row) : act.label}
                            </Link>
                          ) : (
                            <button
                              className={`table-actions ${`${act.className || ""}`} ${
                                act.disabled ? "disabled" : ""
                              }`}
                              disabled={act.disabled ? act.disabled : false}
                              onClick={() => act.onClick(row)}
                            >
                              {act.icon && <> {act.icon} </>}
                              {/* {act.label} */}
                              {typeof act.label === "function" ? act.label(row) : act.label}
                            </button>
                          )}
                        </td>
                      ))}
                    </tr>
                  </React.Fragment>
                ))
              // : (
              //   <tr>
              //     <th className='checkbox'>
              //       <Form.Check
              //         type='checkbox'
              //         id='default-checkbox'
              //         onChange={handleSelectAll}
              //         checked={rowData.length === selectedRows.length}
              //         // checked={rowData.every(
              //         //     (row: any) => row.selected
              //         // )}
              //       />
              //     </th>
              //     <th className='srNo'>
              //       <h4>Sr.No</h4>
              //     </th>
              //     {columns.map((column, index) => (
              //       <th
              //         key={index}
              //         className={column.className}
              //         onClick={() => {
              //           column.sort ? handleSort(column.id) : console.log("sort")
              //         }}
              //       >
              //         <div className='table-name'>
              //           <h4>{column.name}</h4>
              //           {sortColumn === column.id ? (
              //             <h4 className=' cursor-pointer'>{sortOrder === "ASC" ? "▲" : "▼"}</h4>
              //           ) : column.sort ? (
              //             <svg
              //               xmlns='http://www.w3.org/2000/svg'
              //               fill='none'
              //               viewBox='0 0 24 24'
              //               strokeWidth={1.5}
              //               stroke='currentColor'
              //               className='size-6'
              //             >
              //               <path
              //                 strokeLinecap='round'
              //                 strokeLinejoin='round'
              //                 d='M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9'
              //               />
              //             </svg>
              //           ) : (
              //             ""
              //           )}
              //         </div>
              //       </th>
              //     ))}
              //     {action.length > 0 && (
              //       <th colSpan={2}>
              //         <h4 className='text-center'>Action</h4>
              //       </th>
              //     )}
              //   </tr>
              // )
            }
          </tbody>
        </table>
      </div>
      {bulkActions && (
        <div className='row my-3 table-topbar'>
          <div className='col-12 col-md-12'>
            <div className='col-12 col-md-12'>
              <div className='filter-section'>
                {bulkActions &&
                  bulkActions.map((filter: FilterData, filterIndex: number) => {
                    return (
                      <Fragment key={filterIndex}>
                        <div className='filter-option-sectin bulk-filter-options'>
                          {filter.type !== "button" && (
                            <label className='filter-title'>{filter.label}</label>
                          )}
                          {(filter.type === "text" || filter.type === "date") && (
                            <input
                              type={filter.type}
                              value={filter.value}
                              className={filter.className}
                              onChange={filter.onChange}
                              disabled={filter.disabled ? filter.disabled : false}
                            />
                          )}

                          {filter.type === "select" && (
                            <select
                              value={filter.value}
                              className={`form-select ${filter.className}`}
                              onChange={filter.onChange}
                              disabled={filter.disabled ? filter.disabled : false}
                            >
                              {filter.option &&
                                filter.option.map((opt: OptionData, optIndex: number) => (
                                  <option
                                    key={optIndex}
                                    value={opt.value}
                                    disabled={opt.disabled ? opt.disabled : false}
                                  >
                                    {opt.label}
                                  </option>
                                ))}
                            </select>
                          )}
                          {filter.type === "button" && (
                            // <Button className={filter.className} onClick={filter.onClick}>
                            //   {filter.icon && filter.icon}
                            //   {filter.label}
                            // </Button>
                            <PrimaryButton
                              icon={filter.icon && filter.icon}
                              label={filter.label}
                              className={filter.className}
                              onClick={() => {
                                filter.onClick()
                                if (setSelected) {
                                  setSelectedRows([])
                                }
                              }}
                            />
                          )}
                        </div>
                      </Fragment>
                    )
                  })}
              </div>
            </div>
          </div>
        </div>
      )}
      {paginate && rowData.length > 0 ? (
        <Pagination
          currentPage={page}
          itemsPerPage={rowsPerPage}
          totalItems={totalItems}
          onPageChange={(newPage) => setPage(newPage)}
          setRowsPerPage={setRowsPerPage}
          itemsLength={rowData.length}
          setPage={setPage}
          rowsPrPageList={[25, 50, 100, 200]}
        />
      ) : (
        ""
      )}
      <ImageModel
        show={isModalOpen}
        onClose={() => {
          setModalOpen(false)
          setTimeout(() => {
            setSelectedImage(null)
          }, 100)
        }}
        selectedImage={selectedImage}
      />
    </div>
  )
}

export default Table
